<template>
  <span class="switch">
    <i v-if="value === true" class="fa fa-toggle-on" aria-hidden="true" @click="updateValue(false)"></i>
    <i v-else class="fa fa-toggle-off c5" aria-hidden="true" @click="updateValue(true)"></i>
  </span>
</template>
<script>
export default {
  name: "character-sheet-shared-toggle",
  props: ["value"],
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>
<style lang="scss" scoped>
.switch {
  cursor: pointer;
  float: right;
  font-size: 1.25em;
  line-height: 0.5em;
  margin-top: 0.15em;
}
</style>
